<template>
  <div>
    <table class="table table-striped">
      <thead>
        <slot>
          <th v-for="(item, columns) in columns" :key="columns">
            <div>
              {{ item }}
            </div>
          </th>
          <th>
            <div>
              Acciones
            </div>
          </th>
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, data) in data" :key="data">
          <td class="td-datos">{{ item.ministerio }}</td>
          <td class="td-datos">{{ item.servicio }}</td>
          <td class="td-datos">{{item.estado}}</td>
          <td class="td-datos">{{ item.avance }}%</td>
          <td class="td-datos">{{ item.rol }}</td>
          <slot name="actions" :item="item"> </slot>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["columns", "dataSource", "data"],
};
</script>

<style scoped>
.td-datos {
  color: #052333;
  text-align: left;
  font-weight: 700;
  font-size: 16px;
}
</style>
